<template>
  <div class="settings-container">
    <div class="top-nav">
      <div class="top-nav-item actions filter">
        <i class="fas icone fa-filter"></i>
        <div class="option-container">
          <div class="options" v-on:click="changeVisibility('reset')">
            {{$t('reset')}}
            <i class="fas fa-undo"></i>
          </div>
          <div
            v-if="card"
            class="options"
            v-for="(tipopratos,key) in card?.dataCatalog?.tabela?.[0]?.colunas" :key="tipopratos?.id_coluna"
            @click="changeVisibility(tipopratos?.id_coluna)"
          >
            {{ colunasMap[tipopratos?.id_coluna] }}
            <input type="checkbox" :checked="!notShow.includes(tipopratos?.id_coluna)"/>
          </div>
        </div>
      </div>
      <div
        :title= "$t('view_by_ingredients')"
        class="top-nav-item actions"
        @click="visibilityByIngsTypeProt"
        :class="{'active': activeMode === 'ings' || activeMode === 'typeProt'}"
      >
      <span v-if="activeMode === 'typeProt'">
        <i class="fas icone fa-drumstick-bite"></i>
      </span>
      <span v-else>
        <i class="fas icone fa-carrot"></i>
      </span>
      </div>
      <div
        :title="$t('view_by_color')"
        class="top-nav-item actions"
        @click="visibilityByColors"
        :class="{'active': activeMode === 'colors'}"
      >
        <i class="fas icone fa-palette"></i>
      </div>
      <div
        :title="$t('view_combinations')"
        class="top-nav-item actions"
        @click="visibilityByCombinacao"
        :class="{'active': activeMode === 'combination'}"
      >
        <i class="fas icone fa-puzzle-piece"></i>
      </div>
      <div
        :title="$t('view_required')"
        class="top-nav-item actions"
        @click="visibilityByOBG"
        :class="{'active': activeMode === 'obg'}"
      >
        <i class="fas icone fa-check"></i>
      </div>
      <div
        :title="$t('view_dish_groupsView_dish_groups')"
        class="top-nav-item actions"
        @click="visibilityByGroups"
        :class="{'active': activeMode === 'groups'}"
      >
        <i class="fas icone fa-coins"></i>
      </div>
      <div
        :title="$t('view_groups_of_selected_dish')"
        class="top-nav-item actions"
        @click="visibilityByGroupsOnPointer"
        :class="{'active': activeMode === 'groupsOnPointer'}"
      >
        <i class="fas icone fa-bullseye"></i>
      </div>
      <div
        :title="$t('generate_excel')"
        class="top-nav-item actions"
        @click="generateExcell"
      >
        <i class="fas icone fa-file-export"></i>
      </div>

      <div
        :title="$t('flexible_rules_plates')"
        class="top-nav-item actions"
        @click="visibilityByFlexRules"
        :class="{'active': activeMode === 'flxRulesPlate'}"
      >
        <i class="fas icone fa-right-left"></i>
      </div>
      
      <div
        :title="$t('conjPorcaoNaoFechado')"
        class="top-nav-item actions"
        @click="visibilityByconjPorcao"
        :class="{'active': activeMode === 'conjPorcao'}"
      >
        <i class="fa-solid fa-percent"></i>
      </div>
      <div
        :title="$t('modoFeedBack')"
        class="top-nav-item actions"
        @click="handleFeedBackMode"
        :class="{'disabled': !(nrcenario), 'active': activeMode === 'feedback'}"
      >
        <i class="fas icone fa-clipboard-question"></i>
      </div>
      <div
        :title="$t('removeScenario')"
        class="top-nav-item actions"
        @click="removeScenario"
        :class="{'disabled': !(nrcenario)}"
      >
        <i class="fas icone fa-trash"></i>
      </div>

      <div
        :title="$t('back_to_original_scenario')"
        class="top-nav-item actions"
        @click="gotoCenarioOriginal"
        :class="{'disabled': !(nrcenario && nrcenario.ORIGINAL)}"
      >
        <i class="fas icone fa-flag"></i>
      </div>

      <div class="top-nav-item tree-item">
        <div class="top-nav-tree-item">
          <div
            class="top-data"
            v-for="(data,key) in dataFromOptimizer"
            v-if="showData.includes(key)"
          >
            <span v-html="'<b>'+trad[key]+': </b>'+data"></span>
          </div>
        </div>
        <div class="top-nav-tree-item">
          <div class="top-data" v-if="dataFromOptimizer.CDFILICUSTO && dataFromOptimizer.CDFILICUSTO !== dataFromOptimizer.CDFILIAL">
            <span><b>{{ $t('const_based_in_unit') }}</b> {{ dataFromOptimizer.CDFILICUSTO }}</span>
          </div>          
          <div class="top-data">
            <span v-html="'<b>'+$t('cost_type')+' </b>'+dataFromOptimizer.costType.NMTIPOCUSTO"></span>
          </div>
          <div class="top-data">
            <span v-html="'<b>'+$t('reference_date')+': </b>'+dataFromOptimizer.DTREFECUSTO"></span>
          </div>
          <div class="top-data" v-if="nrcenario && nrcenario.NRCENARIOVINCULO">
            <span v-html="'<b>'+$t('linked_scenario')+' </b>'+nrcenario.NRCENARIOVINCULO"></span>
          </div>
        </div>
        <div class="top-nav-tree-item cenarios" @mousedown="updateCenarios">
          <div class="cenarios-data">
            <div class="top-data" v-if="nrcenario">
              <span
                v-html="`<b>`+$t('scenery')+`: </b>${nrcenario.NRCENARIOCARDORIGINAL || nrcenario.NRCENARIOCARD}`"
              ></span>
            </div>
            <div class="top-data" v-if="nrcenario">
              <span v-html="`<b>`+$t('operator')+`: </b> ${nrcenario.NMOPERADOR}`"></span>
            </div>
            <div class="top-data" v-if="nrcenario">
              <span v-html="`<b>`+$t('generated_in')+` </b>${nrcenario.DTCENARIOCARD.replace(' 00:00:00','')}`"></span>
            </div>
          </div>
          <div class="scenario-picker">
            <i class="fas icone fa-ellipsis-h"></i>
            <v-select
              class="fieldSelected"
              id="cenarios"
              v-model="nrcenarioChoss"
              :options="cenarios"
              :getOptionLabel="option => option.DESCR"
              @input="changeCenario"
              :class="{'empty': !nrcenario}"
              searchable
              :placeholder="$t('searchScenario')"
              :clear-on-select="false"
              :close-on-select="true"
              :preserve-search="false"
            ></v-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "@/application/libs/util";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { t } from 'i18next'

export default {
  name: "OtimizadorSettings",
  props: ["card", "nrcenario", "cenarios", "feedBackMode"],
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      notShow: [],
      nrcenarioChoss: null,
      activeMode: null,
      showCenData: ["DTCENARIOCARD", "VRPUCENARIO", "VRCUSTPADR"],
      showData: ["CDFILIAL", "DTMESCARD", "NMSERVICO"],
      trad: {
        NMSERVICO: t('service'),
        CDFILIAL: t('unit'),
        service: t('service'),
        DTMESCARD: t('month'),
      },
      dataFromOptimizer:
        this.card.backOfficeData || Util.getFilterInSession(),
        viewModeStep : 0,
    };
  },
  watch: {
    feedBackMode(newVal) {
      if (!newVal && this.activeMode === 'feedback') {
        this.activeMode = null;
      }
      if (newVal && this.activeMode !== 'feedback') {
        this.activeMode = 'feedback';
      }
    }
  },
  computed: {
    colunasMap() {
      const map = {};
      const colunasInfo = this.card?.dataCatalog?.colunas || {};

      for (const coluna of Object.values(colunasInfo)) {
        map[coluna.id_coluna] = coluna.nm_tipoprato;
      }

      return map;
    }
  },
  methods: {
    generateExcell(){
      this.$emit("generateExcell");
    },
    gotoCenarioOriginal() {
      if (this.nrcenario && this.nrcenario.ORIGINAL) {
        this.$emit("moveToOriginalCenario", this.nrcenario.ORIGINAL);
      }
    },
    updateCenarios() {
      this.$emit("updateCenarioRequest", true);
    },
    changeCenario(cenChoss) {
      let nrcenarioChoss = cenChoss;
      this.$emit("changeCenario", nrcenarioChoss);
    },
    changeVisibility(reset = false) {
      if (reset == "reset") {
        this.notShow = [];
      } else {
        const index = this.notShow.indexOf(reset);
        if (index > -1) {
          this.notShow.splice(index, 1);
        } else {
          this.notShow.push(reset);
        }
      }
      this.$emit("collumsToHide", this.notShow);
    },
    removeScenario() {
      this.$emit("removeScenario", this.nrcenarioChoss);
    },
    handleFeedBackMode() {
      this._toggleMode('feedback');
    },
    _emitMode() {
      const mode = this.activeMode;
      this.$emit('update:feedBackMode', mode === 'feedback');
      this.$emit("visibilityMode", {
        vis: mode || 'reset',
        states: {
          ings:             mode === 'ings',
          typeProt:         mode === 'typeProt',
          colors:           mode === 'colors',
          obg:              mode === 'obg',
          groups:           mode === 'groups',
          combination:      mode === 'combination',
          groupsOnPointer:  mode === 'groupsOnPointer',
          flxRulesPlate:    mode === 'flxRulesPlate',
          conjPorcao:       mode === 'conjPorcao',
          feedback:         mode === 'feedback'
        }
      });
    },
    _toggleMode(mode) {
      this.activeMode = this.activeMode === mode ? null : mode;
      this._emitMode();
    },
    visibilityByIngsTypeProt() {
      if      (this.activeMode === 'ings')     this.activeMode = 'typeProt';
      else if (this.activeMode === 'typeProt') this.activeMode = null;
      else                                     this.activeMode = 'ings';
      this._emitMode();
    },
    visibilityByColors()          { this._toggleMode('colors'); },
    visibilityByCombinacao()      { this._toggleMode('combination'); },
    visibilityByOBG()             { this._toggleMode('obg'); },
    visibilityByGroups()          { this._toggleMode('groups'); },
    visibilityByGroupsOnPointer() { this._toggleMode('groupsOnPointer'); },
    visibilityByFlexRules()       { this._toggleMode('flxRulesPlate'); },
    visibilityByconjPorcao()      { this._toggleMode('conjPorcao'); },
  },
  updated() {
    this.nrcenarioChoss = this.nrcenario;
    this.dataFromOptimizer =
      this.card.backOfficeData || Util.getFilterInSession();
  },
  mounted() {},
};
</script>

<style lang="less">
@import (reference) url("../../assets/variables.less");

.settings-container {
  position: relative;
  display: block;
  margin: 0 0 5px 0;
  background: @azul;
  .filter {
    position: relative;
    display: table;
    .option-container {
      opacity: 0;
      background: white;
      left: 50%;
      top: 50%;
      z-index: -10;
      position: absolute;
      max-height: 300px;
      overflow: auto;
      .sombra;
      .options {
        &:first-of-type {
          background: dimgray;
        }
        .clicavel;
        padding: 0 30px 5px 5px;
        margin-bottom: 1px;
        position: relative;
        display: block;
        white-space: nowrap;
        background: @azul;
        color: white;
        border-bottom: solid 1px white;
        input,
        svg {
          top: 0;
          bottom: 0;
          position: absolute;
          right: 5px;
          vertical-align: middle;
          margin: auto;
          display: table;
          &:after {
            position: absolute;
            .full;
          }
        }
      }
    }
    &:hover {
      .option-container {
        opacity: 1;
        z-index: 10;
      }
    }
  }
  .colors {
    &:hover {
      .clicavel;
    }
  }
  .cenarios {
    font-size: 0.8rem;
    color: white;
    select {
      padding: 0;
      margin: 0;
      width: 100%;
    }
    li {
      color: #333;
    }
    .vs__dropdown-option--highlight {
        background: #5897fb;
        color: #fff;
    }
  }
}
.top-nav {
  height: 48px;
  display: grid;
  grid-template-columns: repeat(13, 40px) auto;
  .top-nav-item {
    display: inline-block;
    vertical-align: middle;
    border-radius: 5px;
    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
    &.cenarios {
      width: 100%;
      vertical-align: middle;
      display: table-cell;
      margin: auto;
    }
    &.actions {
      vertical-align: middle;
      display: table-cell;
      margin: auto;
      padding: 5px;
    }
    .fa-file-export,
    .fa-check,
    .fa-carrot,
    .fa-drumstick-bite,
    .fa-filter,
    .fa-palette,
    .fa-coins,
    .fa-object-group,
    .fa-bullseye,
    .fa-flag,
    .fa-puzzle-piece,
    .fa-right-left,
    .fa-trash,
    .fa-clipboard-question,
    .fa-percent {
      color: #9f9f9f;
      font-size: 1.5rem;
    }
    .fa-filter {
      color: white;
    }
    &.active,
    &:hover:not(.tree-item) {
      cursor: pointer;
      background: @vermelho;
      .fa-file-export,
      .fa-check,
      .fa-carrot,
      .fa-drumstick-bite,
      .fa-filter,
      .fa-palette,
      .fa-coins,
      .fa-object-group,
      .fa-bullseye,
      .fa-flag,
      .fa-puzzle-piece,
      .fa-right-left,
      .fa-percent {
        color: white;
      }
    }
    // &:last-of-type {
    //   margin: 0;
    //   padding: 0;
    // }
    .top-data {
      font-size: 0.7rem;
      display: block;
      margin: 0 5px;
      color: #fff;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      white-space: nowrap;
    }
    &.tree-item {
      display: grid;
      padding-left: 10%;
      grid-template-columns: 23% 36% 41%;
    }
  }
}
.top-nav-tree-item {
  display: grid;
  &.cenarios {
    display: grid;
    grid-template-columns: 85% 15%;
    position: relative;
  }
}
.scenario-picker {
  vertical-align: middle;
  display: table-cell;
  margin: auto;
  font-size: 1.8rem;
  padding: 5px;
  cursor: pointer;
  .fa-ellipsis-h {
    color: #9f9f9f;
    font-size: 1.5rem;
  }
  .v-select.fieldSelected {
    display: none;
  }
  &:hover {
    .fa-ellipsis-h {
      color: white;
    }
    .v-select.fieldSelected {
      z-index: 10;
      display: inline-block;
      position: absolute;
      width: 100%;
      right: 0;
      left: 0;
      top: 10px;
      bottom: 0;
      margin: auto 0;
      background-color: white;
      border: 1px solid #ccc;
      border-radius: 4px;

      .vs__dropdown-toggle {
        background: white;
        border: none;
        padding: 0;
      }

      .vs__search {
        color: #333;
        font-size: 14px;
        padding: 8px 12px;
        width: 100%;
        border: none;
        outline: none;
        background: transparent;
      }

      .vs__dropdown-menu {
        top: 100%;
        background: white;
        border: 1px solid #ccc;
        border-radius: 4px;
        max-height: 200px;
        overflow-y: auto;

        li.vs__dropdown-option {
          white-space: normal;
          padding: 8px 12px;
          cursor: pointer;
          
          &:hover {
            background-color: #f0f0f0;
          }
        }
      }
    }
  }
}
</style>